var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
var Icon = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: auto;\n\n    display: block;\n    width: 10px;\n    height: 10px;\n    polygon,\n    rect {\n        ", "\n    }\n"], ["\n    margin: auto;\n\n    display: block;\n    width: 10px;\n    height: 10px;\n    polygon,\n    rect {\n        ",
    "\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                fill: ", ";\n            "], ["\n                fill: ", ";\n            "])), theme.colorControlBorderAccent);
});
var CheckIcon = function () { return (React.createElement(Icon, { viewBox: "0 0 20 20" },
    React.createElement("polygon", { points: "8 15.5 17 6.5 15 4.5 8 11.5 5 8.5 3 10.5 8 15.5" }))); };
export default CheckIcon;
var templateObject_1, templateObject_2;
//# sourceMappingURL=CheckIcon.js.map